__turbopack_context__.v({
  "companyBanner": "OutletsList-module-scss-module__VHPp5W__companyBanner",
  "container": "OutletsList-module-scss-module__VHPp5W__container",
  "drawerOpen": "OutletsList-module-scss-module__VHPp5W__drawerOpen",
  "footerSection": "OutletsList-module-scss-module__VHPp5W__footerSection",
  "gridContainer": "OutletsList-module-scss-module__VHPp5W__gridContainer",
  "headerSection": "OutletsList-module-scss-module__VHPp5W__headerSection",
  "leftContainer": "OutletsList-module-scss-module__VHPp5W__leftContainer",
  "newOrderPanel": "OutletsList-module-scss-module__VHPp5W__newOrderPanel",
  "rightContainer": "OutletsList-module-scss-module__VHPp5W__rightContainer",
  "searchInputContainer": "OutletsList-module-scss-module__VHPp5W__searchInputContainer",
  "wl": "OutletsList-module-scss-module__VHPp5W__wl",
  "wrapper": "OutletsList-module-scss-module__VHPp5W__wrapper",
});
